/**
 * Linkjs加载器
 * @author wenyibin 00267441
 */
import config from "./config";
import coreModule from "@turboui/turbo-ui-sdk";

coreModule.init(config.context, config.configCode);
